import { UserPlus, Upload, CirclePlus, HeartHandshake } from "lucide-react";
import { Button } from "@/components/ui/button";

interface QuickActionsProps {
  onAddContact: () => void;
  onImportGoogle?: () => void;
  onAddMemory: () => void;
  onSetReminder?: () => void;
  showImportGoogle?: boolean;
  showSetReminder?: boolean;
}

export function QuickActions({
  onAddContact,
  onImportGoogle,
  onAddMemory,
  onSetReminder,
  showImportGoogle = true,
  showSetReminder = false,
}: QuickActionsProps) {
  return (
    <div className="mb-8">
      <h3 className="text-[20px] font-bold font-euclid text-wabisabi-plum mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Add Contact / Create Contact Button */}
        <Button
          onClick={onAddContact}
          className="bg-[#F4978E] hover:bg-[#F4978E]/90 text-white px-[40px] py-[40px] h-auto flex items-center justify-center gap-2 text-[16px]"
        >
          <UserPlus className="w-5 h-5" />
          <span>{showImportGoogle ? "Create Contact" : "Add Contact"}</span>
        </Button>

        {/* Import from Google or Set a Reminder Button */}
        {showImportGoogle && onImportGoogle ? (
          <Button
            onClick={onImportGoogle}
            className="bg-[#48BEAA] hover:bg-[#48BEAA]/90 text-white px-[40px] py-[40px] h-auto flex items-center justify-center gap-2 text-[16px]"
          >
            <Upload className="w-5 h-5" />
            <span>Import from Google</span>
          </Button>
        ) : showSetReminder && onSetReminder ? (
          <Button
            onClick={onSetReminder}
            disabled
            className="bg-[#48BEAA] hover:bg-[#48BEAA]/90 text-white px-[40px] py-[40px] h-auto flex items-center justify-center gap-2 disabled:opacity-50 text-[16px]"
          >
            <HeartHandshake className="w-5 h-5" />
            <span>Set a Reminder</span>
          </Button>
        ) : null}

        {/* Add Memory Button */}
        <Button
          onClick={onAddMemory}
          className="bg-[#F09E0F] hover:bg-[#F09E0F]/90 text-white px-[40px] py-[40px] h-auto flex items-center justify-center gap-2 text-[16px]"
        >
          <CirclePlus className="w-5 h-5" />
          <span>Add Memory</span>
        </Button>
      </div>
    </div>
  );
}
